import { TFunction } from 'i18next'

import { getTransferDetails } from 'entities/ticket/lib/getTransferDetails.ts'

import { Transport } from 'shared/api/tours/flights/model'
import { calculateTotalDuration } from 'shared/lib/ticketRender'

export const getFlightSegments = (
  segmentsByDirection: Record<string, Transport[]>,
  t: TFunction<'translation', undefined>,
) => {
  return Object.entries(segmentsByDirection).map(([direction, segments]) => {
    const firstSegment = segments[0]
    const lastSegment = segments[segments.length - 1]
    const allDetails = segments?.[0]?.details?.[0]?.detail?.length || 0

    const timeFlight = calculateTotalDuration(segments)

    return {
      key: `direction-${direction}`,
      data: {
        route: `${firstSegment.departure[0]?.town || ''} – ${lastSegment.arrival[0]?.town || ''}`,
        class: firstSegment.class_ || '',
        departureTime: firstSegment.departure[0]?.time || '',
        departureCode: firstSegment.departure[0]?.portAlias || '',
        arrivalTime: lastSegment.arrival[0]?.time || '',
        arrivalCode: lastSegment.arrival[0]?.portAlias || '',
        duration: t('time_flight', {
          hours: timeFlight.hours,
          minutes: timeFlight.minutes,
        }),
        transfers: getTransferDetails(
          allDetails || segments?.length,
          false,
          false,
        ),
        hasBaggage: parseInt(firstSegment.baggage?.weight || '0') > 0,
        hasHandBaggage: parseInt(firstSegment.cbaggage?.weight || '0') > 0,
        baggageWeight: `${firstSegment.baggage?.weight || ''} ${firstSegment.baggage?.weight_unit || ''}`,
        handBaggageWeight: `${firstSegment.cbaggage?.weight || ''} ${firstSegment.cbaggage?.weight_unit || ''}`,
        airLineLogo: firstSegment.logo_url,
      },
    }
  })
}
